import { restRequest as r, REST_VERBS as i } from "@ado/base-service";
import { createRequestOptionsBuilder as n } from "../../../../libraries/request_options_building/index.js";
import { KnownQueryKey as s } from "../../../../libraries/known_query_parameters/index3.js";
const u = "/api/foundation/site-configuration";
function f(o = void 0, t = void 0) {
  const e = n().setKnownQueryParameters(s.Host).setAdditionalQueryParameters({ countryCode: t, brand: o }).build();
  return r(i.GET, `${u}/v1/values`, e);
}
export {
  f as getConfiguration
};
//# sourceMappingURL=index.js.map
